import vue from 'vue';
import { default as Component } from 'vue-class-component';

import { AppSidebar } from '../../template/app-sidebar';
import { DashboradNavigationBlock } from '../../template/dashborad-navigation-block';

import IocContainer from '../../../container/IocContainer';
import SERVICES from '../../../services/services';

import User from '../../../interfaces/User';


@Component({
  template: require('./profile-page.html'),
  components: {
    'app-sidebar': AppSidebar,
    'dashborad-navigation-block': DashboradNavigationBlock,
  },
})
export class ProfilePage extends vue {
  errors = [];
  newavatar: '';
  success = false;
  image: '';
  
  formUserData = {
    name: this.user.name,
    last_name: this.user.last_name,
    phone: this.user.phone,
    email: this.user.email,
    gender: this.user.gender,
    birthday: this.user.birthday,
    address: this.user.address,
    city: this.user.city,
    country: this.user.country,
    state: this.user.state,
    zip: this.user.zip,
    avatar: this.user.avatar,
  };

  userProvider = IocContainer.get < User > (SERVICES.USER);

  // mounted() {
  //   this.formUserData = {
  //     name: this.$store.getters.user.name,
  //     last_name: this.user.last_name,
  //     phone: this.user.phone,
  //     email: this.user.email,
  //     gender: this.user.gender,
  //     birthday: this.user.birthday,
  //     address: this.user.address,
  //     city: this.user.city,
  //     country: this.user.country,
  //     state: this.user.state,
  //     zip: this.user.zip,
  //     avatar: this.user.avatar,
  //   };
  // }

  get userdata(){
    return this.formUserData = {
          name: this.user.name,
          last_name: this.user.last_name,
          phone: this.user.phone,
          email: this.user.email,
          gender: this.user.gender,
          birthday: this.user.birthday,
          address: this.user.address,
          city: this.user.city,
          country: this.user.country,
          state: this.user.state,
          zip: this.user.zip,
          avatar: this.user.avatar,
        };
  }

  // Preloader
  get loading() {
    return this.$store.state.loadingUser;
  }

  get user() {
    return this.$store.getters.user;
  }

  get adminStorageUrl() {
    return process.env.ADMIN_URL + 'storage/';
  }

  updateProfile() {
    this.userProvider.setUser(this.formUserData).then(
      (response) => {
        this.errors = [];
        this.success = true;
        setTimeout(() => {
          this.success = false;
          location.reload();
          window.scroll(0, 0);
        }, 500);
      },
      (error) => {
        this.success = false;
        this.errors = error.response.data.errors;
        console.error(error.response.data.errors);
      },
    );
  }
  
  onImageChange(e){
    this.image = e.target.files[0];
    let formData = new FormData();
    formData.append("image", this.image);
    this.userProvider.updateavatar(formData).then((response) => {
      this.formUserData.avatar = "users/avatars/" + response.data.name;
      this.userProvider.setUser(this.formUserData);
      setTimeout(() => {
        location.reload();
      }, 600);
    });
  }
}